export default from './PrivateLayout';



// WEBPACK FOOTER //
// ./src/layouts/private-layout/index.js